import React from 'react';
import { useSetupAreaVersionAdminService } from 'nekst-api';
import { ConfirmDeletePopup } from 'features/nekst-widgets';

export function DeleteSetupAreaVersionForm(
  props: {
    setupAreaId: number,
    setupAreaVersion: string,
  }
) {
  const setupAreaVersionAdminService = useSetupAreaVersionAdminService();

  return (
    <ConfirmDeletePopup
      deleteFunc={async () => {
        await setupAreaVersionAdminService.deleteVersion(props.setupAreaId, props.setupAreaVersion);
      }}
      message="Are you sure you want to delete this version?"
      withConfirmationInput
    />
  );
}
